import {Component, inject} from '@angular/core';
import {UserStateService} from '@services/frontend/user-state.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sidebar-navigation-logout',
  templateUrl: './sidebar-navigation-logout.html'
})
export class SidebarNavigationLogout {

  private readonly userStateService = inject(UserStateService);
  private readonly router = inject(Router);

  logout(): void {
    this.userStateService.deleteToken();
    this.router.navigate(['/login']);
  }

}
